.button {
  composes: text from '../text/Text.css';
  border: 1px solid var(--button-border-color);
  padding: 0.4rem 0.8rem;
  border-radius: 0.3rem;
  background-color: var(--button-bg-color);
  color: white;
  text-decoration: none;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.button:hover {
  background-color: var(--button-bg-hover-color);
  border: 1px solid var(--button-border-hover-color);
}

.signin {
  composes: text from '../text/Text.css';
  border: 1px solid var(--login-border-color);
  padding: 0.4rem 0.8rem;
  border-radius: 0.3rem;
  background-color: var(--login-bg-color);
  color: var(--white-color);
  text-decoration: none;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.signin:hover {
  background-color: var(--login-hvr-color);
  /* border: 1px solid var(--button-border-hover-color); */
}

.buttonSkeleton {
  composes: text from '../text/Text.css';
  composes: button;
  border: 1px solid transparent;
  background: 0;
  color: var(--button-bg-color);
}

.buttonSkeleton:hover {
  border: 1px solid var(--button-border-hover-color);
  border-radius: 0.3rem;
  background: 0;
  color: var(--button-bg-color);
}

.danger {
  composes: buttonSkeleton;
  color: var(--red-text-color);
}

.danger:hover {
  border: 1px solid var(--red-text-color);
  border-radius: 0.3rem;
  color: var(--red-text-color);
}

.buttonText {
  composes: text from '../text/Text.css';
  font-size: 0.9rem;
  background: 0;
  align-self: flex-start;
  border: 0;
  color: #3674d7;
  cursor: pointer;
}

.buttonTypeContainer {
  composes: text from '../text/Text.css';
  font-size: 0.9rem;
  background: 0;
  border: 0;
}

.buttonTypeContainer:hover {
  background-color: hsla(240, 9%, 59%, 0.1);
  cursor: pointer;
}

.signText {
  composes: text from '../text/Text.css';
  font-size: 0.9rem;
  background: 0;
  border: 0;
  color: var(--login-text-color);
  cursor: pointer;
}

.buttonIcon {
  font-size: 0.8rem;
  padding: 0;
  align-self: center;
  display: flex;
  background: 0;
  border: 0;
  cursor: pointer;
}

.disabled {
  composes: button;
  background-color: var(--disabled-button-bg-color);
  color: var(--disabled-button-text-color);
  border: 1 solid var(--disabled-button-border-color);
  cursor: not-allowed;
  /* opacity: 0.5; */
}

.disabled:hover {
  background-color: var(--disabled-button-bg-color);
  /* background-color: #55B09B; */
  border: 1 solid var(--disabled-button-border-color);
  outline: none;
}
